import React from 'react';

import PriceCalculator from './PriceCalculator';

import 'react-tabs/style/react-tabs.css';

/**
 * Advanced plan component
 * @param {*} param0
 */
const AdvancedPlan = ({ setViewModal, historyData, pricingData }) => {
    return (
        <>
            <h2>Choose Advanced Plan Details</h2>
            <PriceCalculator setViewModal={setViewModal} />
        </>
    );
};

export default AdvancedPlan;
